import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PaymentMethodCurrencyConverterItem } from '@/models/ps-management/currency-converter.model';

export default
class GetPaymentMethodConverterListRequest extends ApiResourceMethod<PaymentMethodCurrencyConverterItem[]> {
  public perform(paymentMethodId: string): Promise<PaymentMethodCurrencyConverterItem[]> {
    return this.performer.requestWithMapper(
      { url: `${paymentMethodId}/currencyConverterList` },
      ({ data }: BaseResponse<PaymentMethodCurrencyConverterItem[]>) => data,
    );
  }
}
